import { CSSProperties, useState } from 'react';

import { TeacherClassStudentsQueryVariables } from '@school_ify/schoolify-repository/src/teacher/types';

import StyledTooltip from 'components/StyledTooltip/StyledTooltip';
import useGrading from 'application/teacher/dashboard/assignments/useGrading';
import GradesModal from 'views/Dashboard/components/Upcoming/components/GradesModal/GradesModal';
import GradingIcon from 'components/Icons/Grading';

import './GradeTask.scoped.scss';
import { useTranslation } from 'react-i18next';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  content?: any;
  onGrade?: (data: TeacherClassStudentsQueryVariables) => void;
  hideCompleted?: boolean;
}

const GradeTask: React.FC<Props> = ({ content }) => {
  const [modal, toggleModal] = useState(false);
  const { getStudentsForGrading, addStudentGrade } = useGrading();
  const { t } = useTranslation('common');
  function openModalAndGetStudents(id) {
    getStudentsForGrading(id);
    toggleModal(true);
  }

  return (
    <>
      <GradesModal
        openModal={modal}
        handleModal={() => toggleModal(!modal)}
        assignment={content}
        onInputChange={(id, mark) => addStudentGrade(id, mark)}
      />
      <div className="icon pointer" onClick={() => openModalAndGetStudents(content.id)}>
        <StyledTooltip direction="up" tagName="div" content={<p>{t('Grade')}</p>}>
          <div className="dropdown-dots pointer">
            <GradingIcon fontSize={20} />
          </div>
        </StyledTooltip>
      </div>
    </>
  );
};

export default GradeTask;
